// Pure helpers + constants for the client Checkout flow.

// Format a Date to YYYY-MM-DD using LOCAL parts (never toISOString — shifts day east of UTC).
export const toDateOnly = (d) => {
  if (!d) return null;
  const yr = d.getFullYear();
  const mo = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${yr}-${mo}-${day}`;
};

export const parseDateOnly = (s) => (s ? new Date(`${s}T12:00:00`) : null);

export const timeWindows = [
  '6:00 AM - 8:00 AM',
  '7:00 AM - 9:00 AM',
  '8:00 AM - 10:00 AM',
  '9:00 AM - 11:00 AM',
  '10:00 AM - 12:00 PM',
];
